import { swarmRequest } from '@common/helpers/util/requestMiddleware';

const SERVICE_ID = 10486;
const PAYER_TYPE = 3;

class DepositServicePixSafeway {

  static async createOrder(amount) {
    try {
      const req = {
        amount: +amount,
        service: SERVICE_ID,
        payer: {
          forProduct: 'sport',
          Type: PAYER_TYPE,
        },
      }

      const res = await swarmRequest(req, 'deposit_v2');

      if (res.status === 'error')
        return { errorText: 'Something went wrong while getting qr code' };

      return { forwardUrl: res.action }
    } catch {
      return { errorText: 'Something went wrong' };
    }
  }
}

export default DepositServicePixSafeway;